import { render, staticRenderFns } from "./application-page-container-loader.vue?vue&type=template&id=4b4fa0c6"
import script from "./application-page-container-loader.vue?vue&type=script&lang=ts"
export * from "./application-page-container-loader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports